module.exports = __webpack_public_path__ + "static/media/block-duotone.62cffd9f.svg";